import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";

const state = () => ({
  recordId: null,
  communicationLogs: [],
});

const getters = {
  recordId(state) {
    return state.recordId;
  },
  communicationLogs(state) {
    let commLogs = [...state.communicationLogs];

    if (commLogs.length !== 0) {
      return commLogs.sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
    }

    return commLogs;
  },
};

const mutations = {
  setup(state, data) {
    state.communicationLogs = data.communicationLogs;
  },
  reset(state) {
    state.communicationLogs = [];
  },
  setActiveTextRecordModalId(state, recordId) {
    state.recordId = recordId;
  }
};

const actions = {
  setup({commit, state}, recordId) {
    // Make sure you can subscribe to more then one at a time
    if (state.recordId !== null && state.recordId !== recordId) {
      unsubscribeToChannel("activeTextRecordModal", state.recordId);
    }

    commit('setActiveTextRecordModalId', recordId);
    subscribeToChannel("activeTextRecordModal", recordId);

    return api.clientStore.initActiveTextRecordModal(recordId).then(response => {
      commit('setup', response.data);
    });
  },
  tearDown({commit, state}) {
    if (state.recordId !== null) {
      unsubscribeToChannel("activeTextRecordModal", state.recordId);
      commit('reset');
    }
  },
};

const activeTextRecordModalStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default activeTextRecordModalStore;
